import React, { useMemo, useState, useEffect, useRef } from "react"
import "./BedManagement.scss"
// import Button from "../../../components/Button"
import Button from "@mui/material/Button"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
import { COLUMNS } from "./BedManagementColumns"
import { GlobalFilter } from "../../../frontDesk/patientDirectory/GlobalFilter"
import { useHistory } from "react-router"
import {
  deleteBedDetail, getCenterDetails
} from "../../../../core/services/api"
import { fetchRooms } from "../../../../core/services/api/bedManagementService"
import Toast from "../../../../components/Toast"
import { useSelector } from "react-redux"
import Select from "react-select"
import { useLocation } from "react-router-dom"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"


function BedManagement() {
  const [data, setData] = useState([])
  const columns = useMemo(() => COLUMNS, [])
  const componentRef = useRef()
  const history = useHistory()
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly)
  const [displayToast, toggleDisplayToast] = useState<any>()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [role, setRole] = useState<string>()
  const [centerDetail, setCenterDetail] = useState<any>()
  const [centerName, setCenterName] = useState<any>()
  const location = useLocation()
  const [centerId, setCenterId] = useState<any>(location?.state?.centerId)
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })

  if (dropdownCenters != undefined) {
    dropdownCenters.push({ label: 'All Centers', value: '' });
  }
  useEffect(() => {
    setRole(userDetail?.currentRole);
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })
  }, [])



  useEffect(() => {
    console.log(location, "centerId")
    if (userDetail?.currentRole === 'OPERATIONS' || userDetail?.currentRole === 'SYSTEM_ADMIN') {
      fetchRooms(centerId)
        .then((res: any) => {
          console.log("result", res)
          setData(res)
        })
        .catch((err: any) => {
          console.log("err", err)
        })
      return;
    }

    if (location?.state?.previousPath != 'addBed') {
      localStorage.removeItem("globalFilterBed")
    }
    // setCenterId(location?.state?.centerId);
    fetchRooms(userDetail?.currentRole !== 'SYSTEM_ADMIN' ? userDetail?.currentCenter?.centerId : location?.state?.centerId)
      .then((res: any) => {
        console.log("result", res)
        setData(res)
      })
      .catch((err: any) => {
        console.log("err", err)
      })
    setCenterName(location?.state?.centerName);
  }, [location, centerId])


  // useEffect(() => {

  //   fetchAllRooms();

  // }, [centerId])




  function fetchAllRooms() {
    if (userDetail?.currentRole === 'OPERATIONS' || userDetail?.currentRole === 'SYSTEM_ADMIN') {
      fetchRooms(centerId)
        .then((res: any) => {
          console.log("result", res)
          setData(res)
        })
        .catch((err: any) => {
          console.log("err", err)
        })
      return;
    }
    fetchRooms(userDetail?.currentRole !== 'SYSTEM_ADMIN' ? userDetail?.currentCenter?.centerId : centerId)
      .then((res: any) => {
        console.log("result", res)
        setData(res)
      })
      .catch((err: any) => {
        console.log("err", err)
      })
  }

  /**
   * @param {any} path
   */
  const redirectTo = (path: any) => {
    console.log("edit", path)
    history.push({
      pathname: "/addNewBed",
      state: { idValue: path, centerId: centerId, centerName: centerName },
    })
  }



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  const handleDelete = (path: any) => {
    console.log("list", path)
    deleteBedDetail(`${path}`)
      .then((res) => {
        console.log(res, "res")
        fetchAllRooms()
        toggleDisplayToast({
          text: "Bed successfully deleted",
          type: "success"
        })


      })
      .catch((err) => {
        console.log("err", err)
        toggleDisplayToast({
          text: `${err?.response?.data?.message}`,
          type: "error",
        })
      })
  }

  useEffect(() => {
    // Load the stored filter value from local storage
    const storedFilter = localStorage.getItem('globalFilterBed');
    console.log(storedFilter, "stored Filter")
    if (storedFilter) {
      setGlobalFilter(storedFilter); // Apply the stored filter to the table
    }
  }, [setGlobalFilter, data]);

  return (
    <div className="bed-management-wrapper">
      <div className="bed-management-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="manage-staff-text">Bed Management</div>
      </div>
      <div className="bed-management-container">
        <div className="row add-new">
          <div className="col-9"></div>
          <div className="col-3 add-new-text">
            <Button
              className={`button-container ${readOnly ? "read-only-button" : ""}`}
              disabled={readOnly}
              onClick={() =>
                history.push({
                  pathname: `/AddNewBed`,
                  state: { centerId: centerId, centerName: centerName },
                })
              }
            >
              Add New Bed
            </Button>


            {/* {role === 'SYSTEM_ADMIN' ? <> <div className="Filter-location">
              <label style={{ paddingBottom: '10px' }}>Filter By Location</label>
              <Dropdown
                selected={centerId}
                updateDropdown={(option: any) => {
                  setCenterId(option);
                }}
                placeholder="Location"
                options={dropdownCenters}

              />
            </div></> : <></>} */}


          </div>
          <div className="search-container">
            {/* <div> */}
            <div>
              {console.log(globalFilter, "setGlobalFilterValue")}
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
            {/* <div className="col-3"></div> */}
            <div>

              {role === 'SYSTEM_ADMIN' || role === 'OPERATIONS' ? <> <div className="Filter-location">
                <label style={{ paddingBottom: '10px', width: 'fit-content', fontWeight: '800', letterSpacing: '1.25px' }}>Filter By Location</label>
                <div style={{ width: '233px' }}>
                  <Select
                    className="select-payment"
                    styles={customSelectStyles()}
                    name="modeOfPayment"
                    defaultValue={{
                      label: "",
                      value: ""
                    }}
                    value={{
                      label: centerName,
                      value: centerId
                    }}
                    options={dropdownCenters}
                    onChange={(evnt) => {
                      setCenterName(evnt?.label);
                      setCenterId(evnt?.value);
                      //setData({ ...data, securityDepositMode: evnt?.value })
                    }}
                  />
                </div>
              </div></> : <></>}
            </div>

            {/* </div> */}

          </div>
          <div>
            <table
              {...getTableProps()}
              // @ts-ignore
              ref={componentRef}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            paddingLeft: "40px",
                          }}
                        >
                          {column.render("Header")}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody
                className="border-radiusImportant"
                {...getTableBodyProps()}
              >
                {rows.map((row: any) => {
                  prepareRow(row)
                  return (
                    <tr
                      {...row.getRowProps()}
                      // onClick={() => {
                      //   console.log('row', row)
                      //   // @ts-ignore
                      //   redirectTo(row?.original?.id)
                      // }}
                      style={{ cursor: "pointer" }}
                    >
                      {row.cells.map((cell: any) => {
                        return (
                          <td
                            onClick={() => {
                              if (readOnly) return null
                              else {
                                if (
                                  cell?.column?.id?.toLowerCase() === "delete"
                                ) {
                                  // handleDelete(cell?.row?.original?.id)
                                  toggleDisplayToast({
                                    // @ts-ignore
                                    text: `Are you sure you want to delete the bed?`,
                                    type: "warning",
                                    onClickText: "Yes",
                                    // @ts-ignore
                                    patient: cell?.row?.original?.id,
                                  })
                                }
                                if (cell?.column?.id?.toLowerCase() === "edit") {

                                  redirectTo(row?.original?.id)
                                }
                              }
                            }}
                            style={{
                              maxWidth: "300px",
                              width: "350px",
                              wordWrap: "break-word",
                              maxHeight: "100px",
                              paddingLeft: "40px",
                              verticalAlign: "left",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontSize: "18px",
                              lineHeight: "24px",
                              letterSpacing: "1.35px",
                              textAlign: "initial",
                            }}
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
              <tfoot>
                {footerGroups.map((footerGroup) => (
                  <tr {...footerGroup.getFooterGroupProps()}>
                    {footerGroup.headers.map((column) => (
                      <td {...column.getFooterProps()}>
                        {column.render("Footer")}
                      </td>
                    ))}
                  </tr>
                ))}
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      {
        displayToast && (
          <Toast
            // @ts-ignore
            textMessage={displayToast?.text}
            // @ts-ignore
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={
              // @ts-ignore
              displayToast?.onClickText ? displayToast?.onClickText : null
            }
            onClick={() =>
              // @ts-ignore
              displayToast?.patient
                ? // @ts-ignore
                handleDelete(displayToast?.patient)
                : null
            }
            // @ts-ignore
            type={displayToast?.type}
          />
        )
      }
    </div >
  )
}
export default BedManagement
